import React from 'react';

export enum Locale {
  PL = "pl",
  EN = "en",
  DE = "de",
}

const LanguageContext = React.createContext<Locale>(Locale.PL);

export default LanguageContext;

function getDefaultLocale() {
  const browserLocale = navigator.language.split(/[-_]/)[0];
  if (browserLocale === 'pl') {
    return Locale.PL;
  } else if (browserLocale === 'en') {
    return Locale.EN;
  } else if (browserLocale === 'de') {
    return Locale.DE;
  }
  return Locale.PL;
}

export interface OnLanguageStateChangedListener {
  (newLocale: Locale): void;
}

class LanguageStateBase {
  private currentLocale: Locale;
  private handlers: OnLanguageStateChangedListener[];

  constructor() {
    this.currentLocale = getDefaultLocale();
    this.handlers = [];
  }

  public getCurrentLocale() {
    return this.currentLocale;
  }

  public subscribe(fn: OnLanguageStateChangedListener) {
    this.handlers.push(fn);
  }

  public unsubscribe(fn: OnLanguageStateChangedListener) {
    this.handlers = this.handlers.filter(item => (item !== fn));
  }

  public changeLocale(newLocale: Locale) {
    this.currentLocale = newLocale;
    this.handlers.forEach(fn => fn(newLocale));
  }
}

const LanguageState: LanguageStateBase = new LanguageStateBase();

export { LanguageState };

interface Props {

}

interface State {
  currentLocale: Locale;
}

interface CurrentLanguageConsumer {
  (language: Locale): any;
}

export function withCurrentLanguage(consumer: CurrentLanguageConsumer): React.ReactElement {
  class WithCurrentLanguage extends React.Component<Props, State> {
    handler: any;
    constructor(props: Props) {
      super(props);

      this.state = {
        currentLocale: LanguageState.getCurrentLocale(),
      };

      this.handler = this.newLocaleHandler.bind(this);
    }

    private newLocaleHandler(newLocale: Locale) {
      this.setState({
        currentLocale: newLocale,
      });
    }

    componentDidMount() {
      LanguageState.subscribe(this.handler);
    }

    componentWillUnmount() {
      LanguageState.unsubscribe(this.handler);
    }

    render() {
      const currentLocale = this.state.currentLocale;
      return (
        <LanguageContext.Provider value={currentLocale} >
          {consumer(currentLocale)}
        </LanguageContext.Provider>
      );
    }
  }

  return (
    <WithCurrentLanguage />);
};
